import {
CAREER_ADD} from "./careerConstant"

const initialState = {
  careeradd: {},
  isLoading: false,
};

export const careerReducer = (state = initialState, action) => {
  switch (action.type) {
    case CAREER_ADD:
      return {
        ...state,
        careeradd: action.payload,
        isLoading: false,
      };
   

    default:
      return state;
  }
};
